/**
 * FEATURED IN press badges — mobile card behavior.
 *
 * On mobile, product cards show ONE press badge (CSS hides the rest, defaulting
 * to the first). This script re-picks which badge each card shows so that two
 * consecutive cards in the grid never wear the same publication when the
 * product has an alternative (products with a single badge can still collide —
 * nothing to swap to). Desktop is untouched: picks are applied as inline styles
 * only while the mobile media query matches, and cleared when it stops.
 *
 * Re-runs when the facets AJAX pass replaces a product grid
 * (#ProductGridContainer) and on theme-editor section loads.
 */
(function () {
  if (window.__pressBadgesInit) return;
  window.__pressBadgesInit = true;

  var mq = window.matchMedia('(max-width: 749px)');
  var applied = false;

  function apply() {
    var cards = [];
    document.querySelectorAll('.press-badge-wrapper--card').forEach(function (wrapper) {
      var badges = Array.prototype.slice.call(wrapper.querySelectorAll('.press-badge'));
      if (badges.length) cards.push(badges);
    });
    var prevPub = null;
    cards.forEach(function (badges, idx) {
      // Avoid the previous card's pick, and (one-step lookahead) avoid the next
      // card's publication when that card only has one badge — otherwise a
      // multi-badge card would burn the exact pub its locked neighbor must show.
      var next = cards[idx + 1];
      var nextLocked = next && next.length === 1 ? next[0].dataset.pub : null;
      var candidates = badges.filter(function (b) {
        return b.dataset.pub !== prevPub;
      });
      if (!candidates.length) candidates = badges;
      var chosen = null;
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].dataset.pub !== nextLocked) {
          chosen = candidates[i];
          break;
        }
      }
      if (!chosen) chosen = candidates[0];
      badges.forEach(function (badge) {
        badge.style.display = badge === chosen ? 'flex' : 'none';
      });
      prevPub = chosen.dataset.pub;
    });
    applied = true;
  }

  function clear() {
    if (!applied) return;
    document.querySelectorAll('.press-badge-wrapper--card .press-badge').forEach(function (badge) {
      badge.style.display = '';
    });
    applied = false;
  }

  function refresh() {
    if (mq.matches) {
      apply();
    } else {
      clear();
    }
  }

  var debounceTimer;
  function debouncedRefresh() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refresh, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  if (mq.addEventListener) mq.addEventListener('change', refresh);
  else if (mq.addListener) mq.addListener(refresh);

  document.addEventListener('shopify:section:load', debouncedRefresh);

  var grid = document.getElementById('ProductGridContainer');
  if (grid && 'MutationObserver' in window) {
    new MutationObserver(debouncedRefresh).observe(grid, { childList: true, subtree: true });
  }
})();
